/**
 * Imágenes de Unsplash (licencia Unsplash — uso gratuito).
 * Mantiene el mismo tema visual que las búsquedas anteriores de Readdy.
 */
const u = (id: string, w: number, h: number, crop?: 'faces' | 'entropy') =>
  `https://images.unsplash.com/${id}?w=${w}&h=${h}&fit=crop${crop ? `&crop=${crop}` : ''}&auto=format&q=85`;

export const avatars = {
  latinaBiz: u('photo-1580489944761-15a19d654956', 96, 96, 'faces'),
  latinoBiz: u('photo-1472099645785-5658abf4ff4e', 96, 96, 'faces'),
  blackWomanBiz: u('photo-1573496359142-b8d87734a5a2', 96, 96, 'faces'),
  asianManBiz: u('photo-1507003211169-0a1dd7228f2d', 96, 96, 'faces'),
  whiteManBiz: u('photo-1519085360753-af0119f7cbe7', 96, 96, 'faces'),
  seniorAdvisor: u('photo-1560250097-0b93528c311a', 96, 96, 'faces'),
  latinaExec: u('photo-1594744803329-e58b31de8bf5', 96, 96, 'faces'),
  blackManAdvisor: u('photo-1500648767791-00dcc994a43e', 96, 96, 'faces'),
  womanConsultant: u('photo-1551836022-d5d88e9218df', 96, 96, 'faces'),
  restaurantOwner: u('photo-1506794778202-cad84cf45f1d', 96, 96, 'faces'),
  healthcareWoman: u('photo-1551836022-deb4988cc6c0', 96, 96, 'faces'),
  ecommerceMan: u('photo-1519345182560-3f2917c472ef', 96, 96, 'faces'),
  small: {
    latina: u('photo-1580489944761-15a19d654956', 48, 48, 'faces'),
    blackWoman: u('photo-1573496359142-b8d87734a5a2', 48, 48, 'faces'),
    asianMan: u('photo-1507003211169-0a1dd7228f2d', 48, 48, 'faces'),
    whiteMan: u('photo-1519085360753-af0119f7cbe7', 48, 48, 'faces'),
    latino: u('photo-1472099645785-5658abf4ff4e', 48, 48, 'faces'),
    credLatino: u('photo-1472099645785-5658abf4ff4e', 48, 48, 'faces'),
    lm1: u('photo-1551836022-d5d88e9218df', 32, 32, 'faces'),
    lm2: u('photo-1472099645785-5658abf4ff4e', 32, 32, 'faces'),
    lm3: u('photo-1507003211169-0a1dd7228f2d', 32, 32, 'faces'),
    rs56a: u('photo-1580489944761-15a19d654956', 56, 56, 'faces'),
    rs56b: u('photo-1506794778202-cad84cf45f1d', 56, 56, 'faces'),
    rs56c: u('photo-1519345182560-3f2917c472ef', 56, 56, 'faces'),
    cs72a: u('photo-1580489944761-15a19d654956', 72, 72, 'faces'),
    cs72b: u('photo-1506794778202-cad84cf45f1d', 72, 72, 'faces'),
    cs72c: u('photo-1551836022-d5d88e9218df', 72, 72, 'faces'),
    cs72d: u('photo-1519345182560-3f2917c472ef', 72, 72, 'faces'),
    cs72e: u('photo-1573496359142-b8d87734a5a2', 72, 72, 'faces'),
    cs72f: u('photo-1472099645785-5658abf4ff4e', 72, 72, 'faces'),
    testimonial1: u('photo-1580489944761-15a19d654956', 64, 64, 'faces'),
    testimonial2: u('photo-1506794778202-cad84cf45f1d', 64, 64, 'faces'),
    testimonial3: u('photo-1551836022-d5d88e9218df', 64, 64, 'faces'),
    testimonial4: u('photo-1519345182560-3f2917c472ef', 64, 64, 'faces'),
    testimonial5: u('photo-1573496359142-b8d87734a5a2', 64, 64, 'faces'),
    mentor1: u('photo-1560250097-0b93528c311a', 96, 96, 'faces'),
    mentor2: u('photo-1594744803329-e58b31de8bf5', 96, 96, 'faces'),
    aboutTeam1: u('photo-1560250097-0b93528c311a', 320, 380, 'faces'),
    aboutTeam2: u('photo-1580489944761-15a19d654956', 320, 380, 'faces'),
    aboutTeam3: u('photo-1500648767791-00dcc994a43e', 320, 380, 'faces'),
    aboutMentor1b: u('photo-1560250097-0b93528c311a', 96, 96, 'faces'),
    aboutMentor2b: u('photo-1594744803329-e58b31de8bf5', 96, 96, 'faces'),
  },
} as const;

export const scenes = {
  heroEntrepreneur: u('photo-1522071820081-009f0129c71c', 600, 480, 'faces'),
  howStep1: u('photo-1551434678-e076c223a692', 400, 280),
  howStep2: u('photo-1600880292203-757bb62b4baf', 400, 280),
  howStep3: u('photo-1523240795612-9a054b0db644', 400, 280),
  hiw1: u('photo-1551434678-e076c223a692', 520, 340),
  hiw2: u('photo-1600880292203-757bb62b4baf', 520, 340),
  hiw3: u('photo-1522071820081-009f0129c71c', 520, 340),
  hiw4: u('photo-1523240795612-9a054b0db644', 520, 340),
  sllcHero: u('photo-1553877522-43269d4ea984', 560, 340),
  sllcCredit: u('photo-1554224155-6726b3ff858f', 720, 480),
  sllcCtaBg: u('photo-1614850523296-d8c1af93d400', 1440, 600),
  aboutHero1: u('photo-1522071820081-009f0129c71c', 380, 300),
  aboutHero2: u('photo-1600880292203-757bb62b4baf', 380, 260),
  aboutMission1: u('photo-1600880292203-757bb62b4baf', 300, 200),
  aboutMission2: u('photo-1523240795612-9a054b0db644', 300, 200),
  aboutCulture: u('photo-1522071820081-009f0129c71c', 720, 280),
} as const;

export const blogCovers = [
  u('photo-1554224155-6726b3ff858f', 800, 450),
  u('photo-1454165804606-c3d57bc86b40', 800, 450),
  u('photo-1460925895917-afdab827c52f', 800, 450),
  u('photo-1521737711867-e3b97375f902', 800, 450),
  u('photo-1551288049-bebda4e38f71', 800, 450),
  u('photo-1507679799987-c73779587ccf', 800, 450),
  u('photo-1542744173-8e7e53415bb0', 800, 450),
  u('photo-1553877522-43269d4ea984', 800, 450),
  u('photo-1522199710521-72d69614c702', 800, 450),
  u('photo-1522071820081-009f0129c71c', 800, 450),
  u('photo-1504384308090-c894fdcc538d', 800, 450),
  u('photo-1484480974693-6ca0a78fb35b', 800, 450),
  u('photo-1552664730-d307ca884978', 800, 450),
  u('photo-1586281380349-632531db7ed4', 800, 450),
  u('photo-1579621970563-ebec7560ff3e', 800, 450),
] as const;
